"use client";
import { useSession } from "next-auth/react";
import { useEffect, useRef } from "react";

export const UpdateUserTimezone = () => {
  const { data: session, update: updateSession, status } = useSession();

  const updateSessionRef = useRef(updateSession);
  updateSessionRef.current = updateSession;

  const user = session?.user;
  const isAuthenticated = status === "authenticated";
  const lastTimezone = user?.timezone;
  const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    const updateSession = updateSessionRef.current;

    if (currentTimezone !== lastTimezone) {
      updateSession({ timezone: currentTimezone });
    }
  }, [isAuthenticated, currentTimezone, lastTimezone]);

  return null;
};
